import axios from 'axios';

export function getAdvertiserAccount(token) {
    return axios.get(process.env.REACT_APP_API_URL + '/advertiser/account', {
        headers: {
            Authorization: token
        }
    });
}
